import { render } from "./PersonalInfoConspicuousTransactions.vue?vue&type=template&id=142699e6&scoped=true"
import script from "./PersonalInfoConspicuousTransactions.vue?vue&type=script&lang=js"
export * from "./PersonalInfoConspicuousTransactions.vue?vue&type=script&lang=js"

import "./PersonalInfoConspicuousTransactions.vue?vue&type=style&index=0&id=142699e6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-142699e6"]])

export default __exports__